import React from 'react';
import clsx from 'clsx';
import styles from './Section.module.css';

export type SectionTheme = 'dark' | 'deep' | 'alt' | 'gradient';

interface SectionProps {
  id?: string;
  theme?: SectionTheme;
  className?: string;
  containerClassName?: string;
  children: React.ReactNode;
  collapsePadding?: boolean;
}

const MarketingSection: React.FC<SectionProps> = ({
  id,
  theme = 'dark',
  className,
  containerClassName,
  collapsePadding = false,
  children,
}) => {
  return (
    <section
      id={id}
      className={clsx(styles.section, styles[theme], collapsePadding && styles.collapsed, className)}
    >
      <div
        className={clsx(styles.container, !collapsePadding && styles.spacious, containerClassName)}
      >
        {children}
      </div>
    </section>
  );
};

export default MarketingSection;
